import { useCallback } from 'react';
import { useBulkUnassignFromGroupMutation } from './useGroupOperationsMutation';
import { showToast, TOAST_SUCCESS, FIVE_SECONDS } from 'lib/utils';

const toastMessage = (count: number) =>
  count === 1 ? '1 item removed from group' : `${count} items removed from group`;

export const useBulkRemoveFromGroup = (locationId: string) => {
  const bulkUnassignMutation = useBulkUnassignFromGroupMutation(locationId);

  const removeMultipleFromGroup = useCallback(
    async (requestIds: string[], groupId?: string) => {
      if (!locationId || !groupId) return;
      await bulkUnassignMutation.mutateAsync({
        groupId,
        childRequestIds: requestIds,
      });
      showToast(toastMessage(requestIds.length), TOAST_SUCCESS, FIVE_SECONDS);
    },
    [bulkUnassignMutation, locationId]
  );

  return { removeMultipleFromGroup };
};
